/*
 * Collection and search pages: filtering, sort, price slider, pagination, view-as, the
 * mobile filter drawer and search-within-collection. Replaces the Boost app's engine.
 *
 * Two modes, decided by the URL:
 *
 *   Unfiltered  Shopify renders the page. Sort and page changes fetch this section for the
 *               new URL (sort_by, page) and swap it in.
 *
 *   Filtered    Any f.* parameter in the URL (f.size=Small|Medium, f.vendor=..., f.price=
 *               3000-50000, f.q=giraffe). The script loads a compact index of every
 *               product in the collection (templates/collection.dg-index.liquid), filters,
 *               sorts and pages it here, then asks Liquid for just the cards of the page
 *               being shown (templates/search.dg-by-handle.liquid). Cards are always
 *               rendered by snippets/dg-product-card.liquid, never built in JavaScript.
 *
 * Within a group several values are ORed (Small or Medium); groups are ANDed. Which
 * groups a collection has is set in snippets/dg-filter-groups.liquid.
 *
 * Markup: sections/dg-collection.liquid, sections/dg-search.liquid and their snippets.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';
  var COMPACT = '(max-width: 1024px)'; // phones and tablets: View as offers 1 or 2 per row only
  var CLIENT_SORTS = ['price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'created-ascending', 'created-descending'];
  var CARD_CHUNK = 16;   // Liquid allows 20 all_products lookups per render
  var INDEX_PAGES = 12;  // yagni: 12 x 250 = 3000 products; raise if a collection outgrows it

  // Survives section swaps: what the shopper has open that is not in the URL.
  var ui = { view: null, viewCompact: 'grid-2', drawer: false, collapsed: {} };
  var indexCache = {};   // sort key -> promise of the product list in that order
  var baseIndex = null;  // the default-order list, once loaded
  var cardCache = {};    // handle -> card element
  var renderSeq = 0;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function grid() { return $('[data-dg-grid]'); }
  function section() { var g = grid(); return g && g.closest('.shopify-section'); }
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function isCompact() { return window.matchMedia(COMPACT).matches; }
  function context() { return grid().getAttribute('data-dg-context'); }
  function perPage() { return +grid().getAttribute('data-per-page') || 32; }
  function words(text) {
    return String(text).toLowerCase().replace(/[^a-z0-9\s-]/g, ' ').split(/[\s-]+/).filter(function (w) { return w.length > 0; });
  }

  /* ---------- URL state ---------- */

  function readState() {
    var params = new URLSearchParams(location.search);
    var st = { filters: {}, price: null, q: '', sort: params.get('sort_by') || '', page: +params.get('page') || 1, rest: new URLSearchParams() };
    params.forEach(function (value, key) {
      if (key.indexOf('f.') !== 0) {
        if (key !== 'sort_by' && key !== 'page') st.rest.append(key, value);
        return;
      }
      var name = key.slice(2);
      if (name === 'price') {
        var m = /^(\d+)-(\d+)$/.exec(value);
        if (m) st.price = [+m[1], +m[2]];
      } else if (name === 'q') {
        st.q = value.trim();
      } else if (value) {
        st.filters[name] = value.split('|');
      }
    });
    return st;
  }

  function isFiltered(st) { return !!(st.price || st.q || Object.keys(st.filters).length); }

  function buildUrl(st) {
    var g = grid();
    // A collection URL may still carry old-style tags in its path; filtering starts from the collection itself.
    var path = context() === 'collection' ? g.getAttribute('data-url') : location.pathname;
    var params = new URLSearchParams(st.rest.toString());
    Object.keys(st.filters).forEach(function (k) { if (st.filters[k].length) params.set('f.' + k, st.filters[k].join('|')); });
    if (st.price) params.set('f.price', st.price[0] + '-' + st.price[1]);
    if (st.q) params.set('f.q', st.q);
    if (st.sort) params.set('sort_by', st.sort);
    if (st.page > 1) params.set('page', st.page);
    var qs = params.toString();
    return path + (qs ? '?' + qs : '');
  }

  // Go to a state: filter in the browser if it has filters, otherwise let Shopify render it.
  function commit(st, opts) {
    opts = opts || {};
    var url = buildUrl(st);
    if (isFiltered(st)) {
      if (!opts.pop && url !== location.pathname + location.search) history.pushState({ dgCatalog: true }, '', url);
      renderFiltered(st, opts);
    } else {
      go(url, opts);
    }
  }

  /* ---------- unfiltered: Shopify renders, the section is swapped ---------- */

  function go(url, opts) {
    opts = opts || {};
    var sec = section();
    if (!sec) { location.href = url; return; }
    var seq = ++renderSeq;
    var fetchUrl = new URL(url, location.origin);
    fetchUrl.searchParams.set('section_id', sec.id.replace('shopify-section-', ''));
    sec.classList.add('dg-catalog-loading');
    fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (seq !== renderSeq) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (!fresh || !fresh.querySelector('[data-dg-grid]')) throw new Error('no section');
        sec.innerHTML = fresh.innerHTML;
        sec.classList.remove('dg-catalog-loading');
        if (!opts.pop) history.pushState({ dgCatalog: true }, '', url);
        setup();
        if (opts.scroll !== false && !ui.drawer) scrollToGrid();
      })
      .catch(function () { location.href = url; });
  }

  function scrollToGrid() {
    var bar = $('.boost-pfs-filter-wrapper') || grid();
    if (!bar) return;
    var offset = (parseFloat(document.documentElement.style.getPropertyValue('--dg-catalog-top')) || 0) + 70;
    var top = bar.getBoundingClientRect().top + window.pageYOffset - offset;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ---------- the product index ---------- */

  function loadIndex(sort) {
    var key = sort || '';
    if (indexCache[key]) return indexCache[key];
    var g = grid();
    var base = context() === 'collection'
      ? g.getAttribute('data-url') + '?view=dg-index'
      : '/search?view=dg-index&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(g.getAttribute('data-terms') || '');
    if (key) base += '&sort_by=' + encodeURIComponent(key);
    var list = [];
    // One page at a time: the storefront rate-limits bursts.
    function page(n) {
      return fetch(base + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          var data = JSON.parse(text);
          list = list.concat(data.products || []);
          if (n < data.pages && n < INDEX_PAGES) return page(n + 1);
        });
    }
    indexCache[key] = page(1).then(function () {
      if (!key) { baseIndex = list; onIndex(); }
      return list;
    });
    indexCache[key].catch(function () { delete indexCache[key]; });
    return indexCache[key];
  }

  // What the index knows that Liquid could not print: the real price range, and the
  // values of groups such as Product category or Gold Color.
  function onIndex() {
    if (!baseIndex || !grid()) return;
    $$('.boost-pfs-filter-option[data-dg-fill]').forEach(function (opt) {
      var kind = opt.getAttribute('data-dg-kind'), label = opt.getAttribute('data-label');
      var seen = {};
      baseIndex.forEach(function (p) { valuesOf(p, kind, label).forEach(function (v) { seen[v] = true; }); });
      var values = Object.keys(seen).sort(function (a, b) { return a.localeCompare(b); });
      opt.removeAttribute('data-dg-fill');
      if (values.length < 2) return; // one value filters nothing
      var ul = $('ul', opt);
      values.forEach(function (v) {
        var li = document.createElement('li');
        li.className = 'boost-pfs-filter-option-item boost-pfs-filter-option-label';
        li.innerHTML = '<button role="checkbox" class="boost-pfs-filter-button" aria-checked="false"><span class="boost-pfs-check-box" aria-hidden="true"></span><span class="boost-pfs-filter-option-value"></span><span class="boost-pfs-filter-option-amount" aria-label=""></span></button>';
        li.firstChild.setAttribute('data-value', v);
        $('.boost-pfs-filter-option-value', li).textContent = v;
        ul.appendChild(li);
      });
      opt.hidden = false;
    });
    // Liquid lists a tag or vendor if any product in the collection has it, including ones
    // shoppers cannot see. Hide a value nothing in the index carries, so no click gives zero.
    $$('.boost-pfs-filter-option[data-dg-kind="tag"], .boost-pfs-filter-option[data-dg-kind="vendor"]').forEach(function (opt) {
      var kind = opt.getAttribute('data-dg-kind');
      var have = {};
      baseIndex.forEach(function (p) {
        (kind === 'vendor' ? [p.v || ''] : (p.g || [])).forEach(function (v) { have[v.toLowerCase()] = true; });
      });
      var left = 0;
      $$('.boost-pfs-filter-option-item', opt).forEach(function (li) {
        li.hidden = !have[($('button', li).getAttribute('data-value') || '').toLowerCase()];
        if (!li.hidden) left++;
      });
      if (left < (kind === 'vendor' ? 2 : 1)) opt.hidden = true;
    });
    var price = $('.boost-pfs-filter-option[data-dg-kind="price"]');
    if (price && price._dg && baseIndex.length) {
      var lo = Infinity, hi = 0;
      baseIndex.forEach(function (p) { if (p.a < lo) lo = p.a; if (p.b > hi) hi = p.b; });
      price._dg.setBounds(Math.floor(lo / 100), Math.ceil(hi / 100));
      price.hidden = false;
    }
    paintTree(readState());
    syncDrawer();
  }

  function valuesOf(p, kind, label) {
    if (kind === 'vendor') return p.v ? [p.v] : [];
    if (kind === 'category') return [p.c || 'Uncategorized'];
    if (kind === 'option') return p.o && p.o[label] ? p.o[label].split('||') : [];
    return [];
  }

  /* ---------- filtering ---------- */

  function groupDefs() {
    var defs = {};
    $$('.boost-pfs-filter-option[data-key]').forEach(function (opt) {
      defs[opt.getAttribute('data-key')] = { kind: opt.getAttribute('data-dg-kind'), label: opt.getAttribute('data-label') };
    });
    return defs;
  }

  // 0 = no match; 1 = every word found as typed; 2 = found only by allowing a slip.
  function matchQuery(p, qWords) {
    if (!p._w) p._w = words([p.t, p.v, p.y, (p.g || []).join(' ')].join(' '));
    var dist = window.DGSearch && window.DGSearch.distance;
    var fuzzy = false;
    for (var i = 0; i < qWords.length; i++) {
      var q = qWords[i], hit = 0;
      for (var j = 0; j < p._w.length && hit !== 1; j++) {
        var w = p._w[j];
        if (w.indexOf(q) === 0) hit = 1;
        else if (!hit && dist && q.length >= 4) {
          var max = q.length <= 6 ? 1 : 2;
          // Compare against the same-length start of the word too, so "giraf" finds "giraffe".
          if (dist(q, w, max) <= max || (w.length > q.length && dist(q, w.slice(0, q.length), max) <= max)) hit = 2;
        }
      }
      if (!hit) return 0;
      if (hit === 2) fuzzy = true;
    }
    return fuzzy ? 2 : 1;
  }

  // defs: { key: { kind, label } } for the groups on the page (see groupDefs).
  // also: optional { handle: true } of products Shopify's own search found for st.q; they
  // count as matches too, which brings in pieces that only mention the word in their description.
  function applyFilters(list, st, defs, also) {
    var tests = [];
    Object.keys(st.filters).forEach(function (key) {
      var def = defs[key];
      if (!def) return; // a group this page does not have: ignore rather than show nothing
      var wanted = {};
      st.filters[key].forEach(function (v) { wanted[def.kind === 'tag' ? v.toLowerCase() : v] = true; });
      if (def.kind === 'tag') {
        tests.push(function (p) {
          if (!p._g) p._g = (p.g || []).map(function (t) { return t.toLowerCase(); });
          return p._g.some(function (t) { return wanted[t]; });
        });
      } else {
        tests.push(function (p) { return valuesOf(p, def.kind, def.label).some(function (v) { return wanted[v]; }); });
      }
    });
    if (st.price) {
      var lo = st.price[0] * 100, hi = st.price[1] * 100;
      // A piece with several prices counts if any of them falls in the range.
      tests.push(function (p) { return p.b >= lo && p.a <= hi; });
    }
    var qWords = st.q ? words(st.q) : [];
    var out = [];
    list.forEach(function (p) {
      for (var i = 0; i < tests.length; i++) if (!tests[i](p)) return;
      if (qWords.length) {
        var m = matchQuery(p, qWords);
        if (m !== 1 && also && also[p.h]) m = 1.5;
        if (!m) return;
        p._m = m;
      }
      out.push(p);
    });
    // Searching: title/artist/tag matches first, then Shopify's finds, then near misses.
    if (qWords.length) out = [1, 1.5, 2].reduce(function (all, rank) { return all.concat(out.filter(function (p) { return p._m === rank; })); }, []);
    return out;
  }

  function sortList(list, sort) {
    var cmp = {
      'price-ascending': function (x, y) { return x.a - y.a; },
      'price-descending': function (x, y) { return y.b - x.b; },
      'title-ascending': function (x, y) { return x.t.localeCompare(y.t); },
      'title-descending': function (x, y) { return y.t.localeCompare(x.t); },
      'created-ascending': function (x, y) { return x.d - y.d; },
      'created-descending': function (x, y) { return y.d - x.d; }
    }[sort];
    return cmp ? list.slice().sort(cmp) : list;
  }

  // Handles Shopify's search returns for a phrase (first 250, by relevance). Used only to
  // widen search-within-collection; a failure just means the narrower match.
  var searchCache = {};
  function searchHandles(q) {
    if (!q || context() !== 'collection') return Promise.resolve(null);
    if (!searchCache[q]) {
      searchCache[q] = fetch('/search?view=dg-index&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var found = {};
          (JSON.parse(text).products || []).forEach(function (p) { found[p.h] = true; });
          return found;
        })
        .catch(function () { return null; });
    }
    return searchCache[q];
  }

  function loadCards(handles) {
    var missing = handles.filter(function (h) { return !cardCache[h]; });
    var chunks = [];
    for (var i = 0; i < missing.length; i += CARD_CHUNK) chunks.push(missing.slice(i, i + CARD_CHUNK));
    return Promise.all(chunks.map(function (chunk) {
      return fetch('/search?view=dg-by-handle&q=' + encodeURIComponent(chunk.join(' ')), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          $$('.boost-pfs-filter-product-item', new DOMParser().parseFromString(html, 'text/html')).forEach(function (card) {
            cardCache[card.getAttribute('data-handle')] = document.importNode(card, true);
          });
        });
    })).then(function () {
      return handles.map(function (h) { return cardCache[h]; }).filter(Boolean).map(function (c) { return c.cloneNode(true); });
    });
  }

  function renderFiltered(st, opts) {
    opts = opts || {};
    var sec = section();
    var seq = ++renderSeq;
    sec.classList.add('dg-catalog-loading');
    function done() {
      sec.classList.remove('dg-catalog-loading');
      document.documentElement.classList.remove('dg-catalog-pending');
    }
    // Price, title and date can be sorted here; other orders (best selling) come from Shopify.
    var serverOrder = st.sort && CLIENT_SORTS.indexOf(st.sort) === -1 ? loadIndex(st.sort) : null;
    Promise.all([loadIndex(''), serverOrder, searchHandles(st.q)]).then(function (res) {
      if (seq !== renderSeq) return;
      var list = sortList(applyFilters(res[1] || res[0], st, groupDefs(), res[2]), st.sort);
      var size = perPage();
      var pages = Math.max(1, Math.ceil(list.length / size));
      if (st.page > pages) st.page = pages;
      var slice = list.slice((st.page - 1) * size, st.page * size);
      return loadCards(slice.map(function (p) { return p.h; })).then(function (cards) {
        if (seq !== renderSeq) return;
        var g = grid();
        g.innerHTML = '';
        if (!cards.length) {
          var empty = document.createElement('div');
          empty.className = 'dg-catalog-empty';
          empty.innerHTML = '<p>No pieces match those filters. <a href="#" data-dg-clear-all>Clear all filters</a></p>';
          g.appendChild(empty);
        }
        cards.forEach(function (c) { g.appendChild(c); });
        applyView();
        paintCount(list.length);
        paintPager(st.page, pages);
        paintTree(st);
        paintSort(st.sort);
        done();
        if (opts.scroll !== false && !ui.drawer) scrollToGrid();
      });
    }).catch(function () {
      if (seq !== renderSeq) return;
      done();
      // The index could not be read: fall back to the plain page rather than a dead one.
      if (!opts.initial) location.href = buildUrl({ filters: {}, price: null, q: '', sort: st.sort, page: 1, rest: st.rest });
    });
  }

  /* ---------- painting the page to match a state ---------- */

  function paintCount(n) {
    var total = $('.boost-pfs-filter-total-product');
    if (total) total.innerHTML = n + '<span> ' + (n === 1 ? 'Product' : 'Products') + '</span>';
    var show = $('.boost-pfs-filter-number-result');
    if (show) show.textContent = ' (' + n + ')';
  }

  function paintPager(page, pages) {
    var el = $('.boost-pfs-filter-bottom-pagination');
    if (!el) return;
    if (pages < 2) { el.innerHTML = ''; return; }
    function link(n, label, aria) { return '<li><a href="#" data-page="' + n + '" aria-label="Page ' + aria + '" title="Page ' + aria + '">' + label + '</a></li>'; }
    var html = page > 1 ? link(page - 1, '←', 'Previous') : '<li class="boost-pfs-filter-pagination-disabled"><span aria-label="Page Previous">←</span></li>';
    var gap = false;
    for (var n = 1; n <= pages; n++) {
      if (n === page) { html += '<li><span class="boost-pfs-filter-pagination-active" aria-label="Page ' + n + '" aria-current="page">' + n + '</span></li>'; gap = false; }
      else if (n === 1 || n === pages || Math.abs(n - page) <= 2) { html += link(n, n, n); gap = false; }
      else if (!gap) { html += '<li><span aria-label="Page ...">...</span></li>'; gap = true; }
    }
    html += page < pages ? link(page + 1, '→', 'Next') : '<li class="boost-pfs-filter-pagination-disabled"><span aria-label="Page Next">→</span></li>';
    el.innerHTML = '<ul>' + html + '</ul>';
  }

  function paintSort(sort) {
    $$('.boost-pfs-filter-top-sorting').forEach(function (wrap) {
      var label = 'Sort by';
      $$('a[data-sort]', wrap).forEach(function (a) {
        var on = !!sort && a.getAttribute('data-sort') === sort;
        a.classList.toggle('boost-pfs-filter-sort-item-active', on);
        if (on) label = a.textContent;
      });
      var text = $('.boost-pfs-filter-top-sorting-wrapper span span', wrap);
      if (text) text.textContent = label;
    });
  }

  function paintTree(st) {
    var any = false;
    $$('.boost-pfs-filter-option[data-key]').forEach(function (opt) {
      var kind = opt.getAttribute('data-dg-kind');
      if (kind === 'collection') return;
      var count = 0, summary = '';
      if (kind === 'price') {
        if (opt._dg) opt._dg.setValues(st.price);
        if (st.price) { count = 1; summary = st.price[0] + ' - ' + st.price[1]; }
      } else {
        var lower = (st.filters[opt.getAttribute('data-key')] || []).map(function (v) { return v.toLowerCase(); });
        var names = [];
        $$('.boost-pfs-filter-option-item', opt).forEach(function (li) {
          var btn = $('button', li);
          var on = lower.indexOf((btn.getAttribute('data-value') || '').toLowerCase()) !== -1;
          li.classList.toggle('selected', on);
          btn.setAttribute('aria-checked', String(on));
          if (on) names.push($('.boost-pfs-filter-option-value', li).textContent);
        });
        count = names.length;
        summary = names.join(', ');
      }
      if (count) any = true;
      $('.boost-pfs-filter-option-title-count', opt).textContent = count && kind !== 'price' ? count : '';
      $('.boost-pfs-filter-selected-items-mobile', opt).textContent = summary;
      $('.boost-pfs-filter-clear', opt).style.display = count ? '' : 'none';
    });
    if (st.q) any = true;
    var clearAll = $('.boost-pfs-filter-clear-all');
    if (clearAll) clearAll.style.display = any ? '' : 'none';
    var input = $('.boost-pfs-in-collection-search-input');
    if (input && document.activeElement !== input) input.value = st.q;
    var clearQ = $('.boost-pfs-in-collection-search-clear');
    if (clearQ) clearQ.style.display = st.q ? '' : 'none';
  }

  /* ---------- per-render setup ---------- */

  function setup() {
    var g = grid();
    if (!g) return;
    if (!ui.view) ui.view = 'grid-' + (g.getAttribute('data-cols') || 3);
    // Cards Shopify already rendered need not be fetched again.
    $$('.boost-pfs-filter-product-item', g).forEach(function (card) {
      var h = card.getAttribute('data-handle');
      if (h && !cardCache[h]) cardCache[h] = card.cloneNode(true);
    });
    applyView();
    $$('.boost-pfs-filter-option[data-dg-kind="price"]').forEach(buildSlider);
    $$('.boost-pfs-filter-option').forEach(function (opt) {
      var content = $('.boost-pfs-filter-option-content', opt);
      if (ui.collapsed[content.id]) setCollapsed(opt, true);
    });
    if (baseIndex) onIndex();
    syncDrawer();
    if (context() === 'search') loadCollectionsTab();
    // Groups that only the index can fill are worth an early, idle-time load.
    if (!baseIndex && $('.boost-pfs-filter-option[data-dg-fill], .boost-pfs-filter-option[data-dg-kind="price"][hidden]')) {
      (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(function () { loadIndex('').catch(function () {}); });
    }
  }

  // Wide screens choose list or 2-6 columns; phones and tablets choose 1 or 2 per row.
  // Each keeps its own choice, so rotating a tablet does not lose either.
  function applyView() {
    var view = isCompact() ? ui.viewCompact : ui.view;
    var list = view === 'list';
    var n = list ? null : view.split('-')[1];
    $$('.boost-pfs-filter-product-item', grid()).forEach(function (item) {
      item.classList.toggle('boost-pfs-filter-product-item-list', list);
      item.classList.toggle('boost-pfs-filter-product-item-grid', !list);
      if (n) {
        item.className = item.className
          .replace(/boost-pfs-filter-grid-width-\d/, 'boost-pfs-filter-grid-width-' + n)
          .replace(/boost-pfs-filter-grid-width-mb-\d/, 'boost-pfs-filter-grid-width-mb-' + (n > 2 ? 2 : n));
      }
    });
    $$('.boost-pfs-filter-display-item').forEach(function (a) {
      a.classList.toggle('active', a.getAttribute('data-view') === view);
    });
  }

  /* ---------- filter groups ---------- */

  function setCollapsed(opt, collapsed) {
    var content = $('.boost-pfs-filter-option-content', opt);
    opt.classList.toggle('boost-pfs-filter-option-collapsed', collapsed);
    content.style.display = collapsed ? 'none' : (ui.drawer && isMobile() ? 'block' : '');
    $('.boost-pfs-filter-option-title-heading', opt).setAttribute('aria-expanded', String(!collapsed));
    ui.collapsed[content.id] = collapsed;
  }

  function toggleValue(opt, btn) {
    if (opt.getAttribute('data-dg-kind') === 'collection') {
      // A sibling collection is a different page (its own heading and opener), not a filter.
      location.href = btn.getAttribute('data-href');
      return;
    }
    var st = readState();
    var key = opt.getAttribute('data-key');
    var value = btn.getAttribute('data-value');
    var cur = st.filters[key] || [];
    var had = cur.indexOf(value) !== -1;
    if (opt.getAttribute('data-select') === 'single') cur = had ? [] : [value];
    else cur = had ? cur.filter(function (v) { return v !== value; }) : cur.concat(value);
    if (cur.length) st.filters[key] = cur; else delete st.filters[key];
    st.page = 1;
    commit(st, { scroll: false });
  }

  function clearOption(opt) {
    var st = readState();
    if (opt.getAttribute('data-dg-kind') === 'price') st.price = null;
    else delete st.filters[opt.getAttribute('data-key')];
    st.page = 1;
    commit(st, { scroll: false });
  }

  function clearAll() {
    var st = readState();
    st.filters = {}; st.price = null; st.q = ''; st.page = 1;
    commit(st, { scroll: false });
  }

  /* ---------- price slider ----------
   * Draws the same DOM noUiSlider did (the styles in dg-catalog-base.css target it) and
   * drives it with pointer events. Values are whole currency units. The bounds start as
   * 0..max from Liquid and tighten to the collection's real range once the index is in.
   */
  function buildSlider(opt) {
    var el = $('.boost-pfs-filter-option-range-slider', opt);
    if (!el || opt._dg) return;
    var min = +opt.getAttribute('data-min'), max = +opt.getAttribute('data-max');
    var lo = min, hi = max, chosen = false;
    var inMin = $('.boost-pfs-filter-option-range-amount-min', opt);
    var inMax = $('.boost-pfs-filter-option-range-amount-max', opt);
    function handle(which, label) {
      return '<div class="noUi-origin"><div class="noUi-handle noUi-handle-' + which + '" data-handle="' + (which === 'lower' ? 0 : 1) +
        '" tabindex="0" role="slider" aria-orientation="horizontal" aria-label="' + label + '"><div class="noUi-touch-area"></div></div></div>';
    }
    el.innerHTML = '<div class="noUi-base"><div class="noUi-connects"><div class="noUi-connect"></div></div>' +
      handle('lower', 'Min value') + handle('upper', 'Max value') + '</div><div class="noUi-pips noUi-pips-horizontal"></div>';
    var base = $('.noUi-base', el), connect = $('.noUi-connect', el), origins = $$('.noUi-origin', el), handles = $$('.noUi-handle', el), pipsEl = $('.noUi-pips', el);

    function pct(v) { return max > min ? (v - min) / (max - min) * 100 : 0; }
    function drawPips() {
      var html = '';
      // Five ticks, three labels: with every tick labelled, five-figure prices ran into each other.
      [0, 25, 50, 75, 100].forEach(function (p) {
        var v = Math.round(min + (max - min) * p / 100);
        html += '<div class="noUi-marker noUi-marker-horizontal noUi-marker-large" style="left: ' + p + '%;"></div>';
        if (p % 50 === 0) {
          html += '<div class="noUi-value noUi-value-horizontal noUi-value-large' + (p === 0 ? ' dg-pip-first' : p === 100 ? ' dg-pip-last' : '') +
            '" data-value="' + v + '" style="left: ' + p + '%;">' + v.toLocaleString('en-US') + '</div>';
        }
      });
      pipsEl.innerHTML = html;
      handles.forEach(function (h) { h.setAttribute('aria-valuemin', min); h.setAttribute('aria-valuemax', max); });
    }
    function paint() {
      var a = pct(lo), b = pct(hi);
      origins[0].style.transform = 'translate(' + (-(100 - a) * 10) + '%, 0px)';
      origins[1].style.transform = 'translate(' + (-(100 - b) * 10) + '%, 0px)';
      origins[0].style.zIndex = a > 50 ? 5 : 4;
      origins[1].style.zIndex = a > 50 ? 4 : 5;
      connect.style.transform = 'translate(' + a + '%, 0px) scale(' + ((b - a) / 100) + ', 1)';
      handles[0].setAttribute('aria-valuenow', lo);
      handles[1].setAttribute('aria-valuenow', hi);
      inMin.value = lo;
      inMax.value = hi;
    }
    function set(which, v) {
      v = Math.round(Math.min(max, Math.max(min, v)));
      if (which === 0) lo = Math.min(v, hi); else hi = Math.max(v, lo);
      paint();
    }
    function commitPrice() {
      var st = readState();
      var next = lo > min || hi < max ? [lo, hi] : null;
      if (String(next) === String(st.price)) return;
      st.price = next;
      st.page = 1;
      commit(st, { scroll: false });
    }
    function valueAt(clientX) {
      var r = base.getBoundingClientRect();
      return min + (max - min) * Math.min(1, Math.max(0, (clientX - r.left) / r.width));
    }
    handles.forEach(function (h, i) {
      h.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        h.setPointerCapture(e.pointerId);
        h.classList.add('noUi-active');
        function move(ev) { set(i, valueAt(ev.clientX)); }
        function up() {
          h.classList.remove('noUi-active');
          h.removeEventListener('pointermove', move);
          h.removeEventListener('pointerup', up);
          h.removeEventListener('pointercancel', up);
          commitPrice();
        }
        h.addEventListener('pointermove', move);
        h.addEventListener('pointerup', up);
        h.addEventListener('pointercancel', up);
      });
      h.addEventListener('keydown', function (e) {
        var step = Math.max(1, Math.round((max - min) / 100));
        var cur = i === 0 ? lo : hi;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') set(i, cur - step);
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') set(i, cur + step);
        else if (e.key === 'Home') set(i, min);
        else if (e.key === 'End') set(i, max);
        else return;
        e.preventDefault();
        clearTimeout(h._t);
        h._t = setTimeout(commitPrice, 600);
      });
    });
    base.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.noUi-handle')) return;
      var v = valueAt(e.clientX);
      set(Math.abs(v - lo) <= Math.abs(v - hi) ? 0 : 1, v);
      commitPrice();
    });
    [inMin, inMax].forEach(function (input, i) {
      input.addEventListener('change', function () {
        var v = parseFloat(String(input.value).replace(/[^0-9.]/g, ''));
        if (isNaN(v)) { paint(); return; }
        set(i, v);
        commitPrice();
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    });
    opt._dg = {
      setBounds: function (newMin, newMax) {
        min = newMin; max = Math.max(newMax, newMin);
        if (!chosen) { lo = min; hi = max; }
        lo = Math.min(max, Math.max(min, lo)); hi = Math.min(max, Math.max(lo, hi));
        drawPips(); paint();
      },
      setValues: function (range) {
        chosen = !!range;
        lo = range ? Math.min(max, Math.max(min, range[0])) : min;
        hi = range ? Math.max(lo, Math.min(max, range[1])) : max;
        paint();
      }
    };
    drawPips();
    paint();
  }

  /* ---------- mobile drawer ----------
   * Below 768px the tree is a drawer that slides in from the right. Every group is open
   * inside it and the list scrolls as one; a group's heading still folds it away.
   * State lives in `ui` so it survives a section swap.
   */
  var drawerTimer;
  function syncDrawer(animate) {
    var tree = $('#boost-pfs-filter-tree');
    if (!tree) return;
    var open = ui.drawer && isMobile();
    var wasOpen = tree.classList.contains('boost-pfs-filter-tree-mobile-open');
    function setOpen(on) {
      tree.classList.toggle('boost-pfs-filter-mobile-style2', on);
      tree.classList.toggle('boost-pfs-filter-tree-mobile-open', on);
      document.body.classList.toggle('boost-pfs-filter-mobile-style2-body', on);
      document.body.classList.toggle('boost-pfs-filter-tree-open-body', on);
      document.documentElement.classList.toggle('boost-pfs-body-no-scroll', on);
      // The option list is position:fixed in the drawer and has to start under the toolbar.
      var wrap = $('.boost-pfs-filter-options-wrapper', tree);
      var bar = $('.boost-pfs-filter-mobile-toolbar', tree);
      if (wrap) wrap.style.top = on && bar ? bar.offsetHeight + 'px' : '';
      $$('.boost-pfs-filter-option', tree).forEach(function (opt) {
        var content = $('.boost-pfs-filter-option-content', opt);
        content.style.display = ui.collapsed[content.id] ? 'none' : (on ? 'block' : '');
      });
    }
    clearTimeout(drawerTimer);
    if (open) {
      setOpen(true);
      if (!wasOpen && animate) { tree.classList.remove('dg-drawer-in'); void tree.offsetWidth; } // start off-screen, then slide
      tree.classList.add('dg-drawer-in');
      document.body.classList.add('dg-drawer-in-body');
    } else if (wasOpen) {
      tree.classList.remove('dg-drawer-in');
      document.body.classList.remove('dg-drawer-in-body');
      if (animate) drawerTimer = setTimeout(function () { if (!ui.drawer) setOpen(false); }, 300); // matches the CSS transition
      else setOpen(false);
    } else {
      setOpen(false);
    }
  }

  /* ---------- search page: the Collections tab ---------- */

  function loadCollectionsTab() {
    var g = grid();
    var terms = g.getAttribute('data-terms');
    var panel = $('[data-dg-collections-panel] .boost-pfs-search-result-collections');
    var tab = $('[data-dg-panel="collections"]');
    if (!terms || !panel || !tab) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(terms) + '&resources%5Btype%5D=collection&resources%5Blimit%5D=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var cols = (data.resources && data.resources.results && data.resources.results.collections) || [];
        if (!cols.length) return;
        panel.innerHTML = '';
        cols.forEach(function (c) {
          var item = document.createElement('div');
          item.className = 'boost-pfs-search-result-list-item boost-pfs-search-result-list-item-collection';
          var a = document.createElement('a');
          a.href = c.url;
          a.title = c.title;
          a.innerHTML = '<div class="boost-pfs-search-result-list-item-content"><div class="boost-pfs-search-result-list-item-title"></div></div>';
          a.querySelector('.boost-pfs-search-result-list-item-title').textContent = c.title;
          item.appendChild(a);
          panel.appendChild(item);
        });
        $('[data-dg-collections-count]', tab).textContent = cols.length;
        tab.hidden = false;
      })
      .catch(function () {});
  }

  function showPanel(name) {
    $$('.boost-pfs-search-result-panel-item').forEach(function (li) {
      li.classList.toggle('boost-active', li.getAttribute('data-dg-panel') === name);
    });
    $$('.boost-pfs-search-panel-product-show').forEach(function (el) { el.classList.toggle('boost-hidden', name !== 'products'); });
    var panel = $('[data-dg-collections-panel]');
    if (panel) panel.classList.toggle('boost-hidden', name !== 'collections');
  }

  /* ---------- events (bound once, delegated) ---------- */

  function closeSortMenus(except) {
    $$('.boost-pfs-filter-filter-dropdown').forEach(function (ul) {
      if (ul === except) return;
      ul.style.display = 'none';
      var b = ul.previousElementSibling;
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function searchWithin(value) {
    var st = readState();
    value = value.trim();
    if (value === st.q) return;
    st.q = value;
    st.page = 1;
    commit(st, { scroll: false });
  }

  document.addEventListener('click', function (e) {
    if (!grid()) return;
    var t = e.target;
    var el, st;

    if ((el = t.closest('.boost-pfs-filter-top-sorting-wrapper'))) {
      var menu = el.parentNode.querySelector('.boost-pfs-filter-filter-dropdown');
      var show = menu.style.display !== 'block';
      closeSortMenus(menu);
      menu.style.display = show ? 'block' : 'none';
      el.setAttribute('aria-expanded', String(show));
      return;
    }
    if ((el = t.closest('.boost-pfs-filter-filter-dropdown a[data-sort]'))) {
      e.preventDefault();
      st = readState();
      st.sort = el.getAttribute('data-sort');
      st.page = 1;
      closeSortMenus();
      commit(st);
      return;
    }
    closeSortMenus();

    if ((el = t.closest('.boost-pfs-filter-display-item'))) {
      e.preventDefault();
      if (isCompact()) ui.viewCompact = el.getAttribute('data-view');
      else ui.view = el.getAttribute('data-view');
      applyView();
      return;
    }
    if ((el = t.closest('.boost-pfs-filter-bottom-pagination a'))) {
      e.preventDefault();
      if (el.hasAttribute('data-page')) { st = readState(); st.page = +el.getAttribute('data-page'); commit(st); }
      else go(el.getAttribute('href'));
      return;
    }
    if ((el = t.closest('.boost-pfs-filter-tree-mobile-button button'))) {
      ui.drawer = true; syncDrawer(true);
      loadIndex('').catch(function () {});
      return;
    }
    if (t.closest('.boost-pfs-filter-close') || t.closest('.boost-pfs-filter-show-result') || t.closest('.dg-drawer-backdrop')) {
      ui.drawer = false; syncDrawer(true);
      return;
    }
    if (t.closest('.boost-pfs-filter-clear-all') || t.closest('[data-dg-clear-all]')) {
      e.preventDefault();
      clearAll();
      return;
    }
    if ((el = t.closest('.boost-pfs-filter-clear'))) {
      var owner = el.closest('.boost-pfs-filter-option');
      if (owner) clearOption(owner);
      return;
    }
    if ((el = t.closest('.boost-pfs-filter-option-title-heading'))) {
      var opt = el.closest('.boost-pfs-filter-option');
      setCollapsed(opt, !opt.classList.contains('boost-pfs-filter-option-collapsed'));
      return;
    }
    if ((el = t.closest('.boost-pfs-filter-option-item .boost-pfs-filter-button'))) {
      toggleValue(el.closest('.boost-pfs-filter-option'), el);
      return;
    }
    if (t.closest('.boost-pfs-in-collection-search-button')) {
      searchWithin($('.boost-pfs-in-collection-search-input').value);
      return;
    }
    if (t.closest('.boost-pfs-in-collection-search-clear')) {
      $('.boost-pfs-in-collection-search-input').value = '';
      searchWithin('');
      return;
    }
    if ((el = t.closest('.boost-pfs-search-result-panel-item'))) {
      showPanel(el.getAttribute('data-dg-panel'));
      return;
    }
  });

  // Search-within filters as you type.
  var typing;
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('boost-pfs-in-collection-search-input')) return;
    var value = e.target.value;
    clearTimeout(typing);
    typing = setTimeout(function () { searchWithin(value); }, 250);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('boost-pfs-in-collection-search-input')) {
      e.preventDefault();
      clearTimeout(typing);
      searchWithin(e.target.value);
    }
    if (e.key === 'Escape') {
      closeSortMenus();
      if (ui.drawer) { ui.drawer = false; syncDrawer(true); }
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.boost-pfs-filter-close')) {
      e.preventDefault();
      e.target.click();
    }
  });

  // Reaching for the filters is the cue to fetch the index, so the first click is instant.
  document.addEventListener('pointerover', function (e) {
    if (baseIndex || indexCache[''] || !grid()) return;
    if (e.target.closest && e.target.closest('#boost-pfs-filter-tree, .boost-pfs-in-collection-search')) loadIndex('').catch(function () {});
  }, { passive: true });

  window.addEventListener('popstate', function () {
    if (grid()) commit(readState(), { pop: true, scroll: false });
  });

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      // Below 768px the Sort / Refine bar pins to the top once it scrolls out of view.
      var bar = $('.boost-pfs-filter-toolbar-sticky-mobile');
      if (!bar) return;
      document.body.classList.toggle('boost-pfs-mobile-stick', isMobile() && bar.getBoundingClientRect().top < 0);
      // Desktop: tell the sticky toolbar and filter column how much room the site nav takes.
      var nav = document.getElementById('StickyBar');
      var navH = nav && nav.classList.contains('sticky--active') ? nav.offsetHeight : 0;
      var toolbar = $('.boost-pfs-filter-default-toolbar');
      var root = document.documentElement.style;
      root.setProperty('--dg-catalog-top', navH + 'px');
      if (toolbar) root.setProperty('--dg-catalog-bar', toolbar.offsetHeight + 'px');
      // Let the bar go once the grid has scrolled away, so it does not ride over the
      // collection description at the foot of the page.
      var cols = $('.boost-pfs-filter-right-col');
      if (toolbar && cols) toolbar.classList.toggle('dg-toolbar-released', cols.getBoundingClientRect().bottom < navH + toolbar.offsetHeight);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { applyView(); syncDrawer(); onScroll(); });

  function start() {
    setup();
    if (!grid()) return;
    var st = readState();
    if (isFiltered(st)) renderFiltered(st, { initial: true, scroll: false });
    onScroll();
  }
  // A filtered page is hidden until it is drawn; never leave it hidden if something stalls.
  setTimeout(function () { document.documentElement.classList.remove('dg-catalog-pending'); }, 8000);

  if (typeof document.addEventListener === 'function') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }

  // Exposed for scripts/dg-catalog-check.cjs and for debugging.
  window.DGCatalog = { applyFilters: applyFilters, sortList: sortList, matchQuery: matchQuery, words: words };
})();
